import { useState, useEffect } from 'react';
import useDataBean from '../../../../../../core/services/dataBean/useDataBean';
import { _UBLNotification } from '../../../../../../core/services/dataBean/EntityCatalog';
import { toast } from 'react-toastify';

interface Props {
    idSelector: string;
    onChange: any;
    label?: string;
}

export const SelectUBLNotificationTypeConstants = ({ idSelector, onChange, label }: Props) => {

    const { instance, lista, setLista } = useDataBean(_UBLNotification);
    const [id, setID] = useState<number>();

    useEffect(() => {
        getLista();
    }, [])

    const setValue = (e: any) => {
        
        onChange(e);
    }


    const getLista = () => {
        instance.getRadianPurchaseEvents(0).then(
            (resp) => {
                setLista(resp)
            }
        ).catch(err => { toast.error(err) })
    }

    return (
        <>
            <label>{label ?? "Tipo"}</label>
            <select className="form-select" value={id} onChange={(e) => { setValue(e.target.value) }}>
                <option value={""}>...</option>
                {lista &&
                    lista.map((item: any) => {
                        return (
                            <option key={item.DataBeanProperties.Code} value={item.DataBeanProperties.Code} >{item.DataBeanProperties.Name}</option>
                        )
                    })
                }
            </select>
        </>
    )
}